{
  "nl": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Verander logo (png vereist)",
        "changeThemeColor": "Kies een nieuw themakleur"
      },
      "labels": {
        "customerThemeColor": "Themakleur klant",
        "customerThemeColorExlainer": "Dit kleur wordt gebruikt voor het klantenportaal. Impersoneer een klant om dit in actie te zien.",
        "logo": "Logo"
      },
      "picture_logo_format": {
        "round": "Rond logo",
        "square": "Vierkant logo"
      }
    }
  }
}
